module.exports = __webpack_public_path__ + "img/routine.2f0a80e6.svg";